import { Component, OnInit } from '@angular/core';
import { LayoutConfigService, OffcanvasOptions } from '@app/core/_base/layout';

@Component({
  selector: 'kt-sticky-menu',
  templateUrl: './sticky-menu.component.html',
  styleUrls: ['./sticky-menu.component.scss']
})
export class StickyMenuComponent implements OnInit {



 

  // Public properties
	demoPanelOptions: OffcanvasOptions = {
		overlay: true,
		baseClass: 'kt-demo-panel',
		// closeBy: 'kt_demo_panel_close',
		// toggleBy: 'kt_demo_panel_toggle',
    closeBy: 's_close',
		toggleBy: 's_toggle',
	};

	baseHref: string;

	constructor(private layoutConfigService: LayoutConfigService) {
		this.baseHref = 'https://keenthemes.com/metronic/preview/angular/';
	}

  ngOnInit() {
  }

	isActiveDemo(demo) {
		return demo === this.layoutConfigService.getConfig('demo');
	}

}
